// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_rMY","cls2":"OnboardingTour-cls2_aGD OnboardingTour-cls1_rMY"};